import { EducationalInformationLoader } from './parts/EducationalInformationLoader';
import Header from './parts/Header';
import { MainStudies } from './parts/MainStudies/MainStudies';
import { OtherStudies } from './parts/OtherStudies/OtherStudies';
import { OtherStudiesLoader } from './parts/OtherStudies/OtherStudiesLoader';
import { OtherStudiesForm } from './parts/OtherStudiesForm/OtherStudiesForm';
import { useMemo, useState } from 'react';
import { FormValues } from './types';
import { OtherStudiesFormLoader } from './parts/OtherStudiesForm/OtherStudiesFormLoader';

import { PermissionName } from '../../../../types/Auth';
import useUserState from '../../../../hooks/useUserState';

export const EducationalInformation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [recordToEdit, setRecordToEdit] = useState<FormValues | undefined>(
    undefined,
  );
  const { isAuthorizedTo } = useUserState();

  const toggleEdit = (record: FormValues) => {
    setRecordToEdit(record);
    setIsOpen(!isOpen);
  };

  const closeModal = () => {
    setRecordToEdit(undefined);
    setIsOpen(false);
  };

  const hasPermission = useMemo(
    () =>
      isAuthorizedTo(
        [PermissionName.STUDENT_MANAGEMENT_STUDENT_FILE_MANAGE],
        true,
      ),
    [isAuthorizedTo],
  );

  return (
    <>
      <EducationalInformationLoader>
        {({ postulant, mainStudies, studentId }) => (
          <>
            <Header postulant={postulant} />
            <MainStudies mainStudiesData={mainStudies} />
            {hasPermission ? (
              <OtherStudiesFormLoader>
                {({ academicLevels, countries, institutions, loading }) => (
                  <OtherStudiesLoader>
                    {({
                      otherStudies,
                      otherStudiesPagination,
                      query,
                      updateQuery,
                      refresh,
                    }) => (
                      <>
                        <OtherStudiesForm
                          isOpen={isOpen}
                          setIsOpen={setIsOpen}
                          recordToEdit={recordToEdit}
                          closeModal={closeModal}
                          studentId={studentId}
                          refresh={refresh}
                          loading={loading}
                          academicLevels={academicLevels}
                          countries={countries}
                          institutions={institutions}
                        />
                        <OtherStudies
                          otherStudies={otherStudies}
                          paginationData={otherStudiesPagination}
                          query={query}
                          updateQuery={updateQuery}
                          toggleEdit={toggleEdit}
                          refresh={refresh}
                          hasPermission={hasPermission}
                        />
                      </>
                    )}
                  </OtherStudiesLoader>
                )}
              </OtherStudiesFormLoader>
            ) : (
              <OtherStudiesLoader>
                {({
                  otherStudies,
                  otherStudiesPagination,
                  query,
                  updateQuery,
                  refresh,
                }) => (
                  <>
                    <OtherStudies
                      otherStudies={otherStudies}
                      paginationData={otherStudiesPagination}
                      query={query}
                      updateQuery={updateQuery}
                      toggleEdit={toggleEdit}
                      refresh={refresh}
                      hasPermission={hasPermission}
                    />
                  </>
                )}
              </OtherStudiesLoader>
            )}
          </>
        )}
      </EducationalInformationLoader>
    </>
  );
};
